// surveyApi.ts — Base URL helper for survey API calls
// eslint-disable-next-line @typescript-eslint/no-var-requires
const DomainInfo = require('../../helpers/DomainInfo');

const BASE: string = DomainInfo.baseUrl;

/**
 * Full URL for a survey API path. Pass the survey slug (e.g. 'bsm2026') to
 * scope the call to that event survey; without it the backend uses the
 * current survey (Survey.Survey.is_current).
 */
export function surveyUrl(path: string, slug?: string | null): string {
  if (!slug) return `${BASE}${path}`;
  const sep = path.includes('?') ? '&' : '?';
  return `${BASE}${path}${sep}survey=${encodeURIComponent(slug)}`;
}

// Admin pages live under /survey/ too, so these can never be survey slugs.
const ADMIN_SEGMENTS = ['statistics', 'config'];

/**
 * The survey slug in a public survey path: '/survey' -> null (current survey),
 * '/survey/labc2026' -> 'labc2026'. Returns undefined when the path is not a
 * public survey page (including the admin pages).
 */
export function surveySlugFromPath(pathname: string): string | null | undefined {
  const match = pathname.replace(/\/+$/, '').match(/^\/survey(?:\/([^/]+))?$/);
  if (!match) return undefined;
  const slug = match[1]?.toLowerCase();
  if (!slug) return null;
  return ADMIN_SEGMENTS.includes(slug) ? undefined : slug;
}

export function isPublicSurveyPath(pathname: string): boolean {
  return surveySlugFromPath(pathname) !== undefined;
}

/**
 * An extra multiple-choice question on an event survey (Survey.Survey
 * .extra_questions, e.g. BSM 2026's vendor and postcard questions). Answers
 * are stored per response as { [key]: option value }.
 */
export interface SurveyQuestion {
  key: string;
  label: string;
  options: { value: string; label: string }[];
}
